customElements.define('sticky-subcollections',
  class StickySubcollections extends HTMLElement {
    constructor() {
      super();
      this.scrollTicking = false;
    }

    connectedCallback() {
      this.subcollections = document.querySelector('.section-subcollections');
      if (!this.subcollections) return;
      this.subcollectionsBounds = {};
      this.currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
      this.preventReveal = false;
      this.onScrollHandler = this.onScroll.bind(this);
      this.hideOnScrollUp = () => this.preventReveal = true;
      this.resizeHandler = this.setSubcollectionsHeight.bind(this);
      this.addEventListener('preventSubcollectionsReveal', this.hideOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);
      window.addEventListener('resize', this.resizeHandler);
      this.createObserver();
      window.requestAnimationFrame(() => this.onScroll());
    }

    disconnectedCallback() {
      this.removeEventListener('preventSubcollectionsReveal', this.hideOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      window.removeEventListener('resize', this.resizeHandler);
    }

    setSubcollectionsHeight() {
      const height = this ? this.offsetHeight : this.section.offsetHeight;
      document.documentElement.style.setProperty('--subcollections-height', `${height}px`);
    }

    createObserver() {
      const observer = new IntersectionObserver((entries) => {
        const entry = entries[0];
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        const rect = entry.boundingClientRect;

        this.subcollectionsBounds = {
          top: scrollTop + rect.top,
          bottom: scrollTop + rect.bottom
        };

        observer.disconnect();
      });
      observer.observe(this.subcollections);
    }

    onScroll() {
      if (!this.scrollTicking) {
        window.requestAnimationFrame(() => {
          this._handleScroll();
          this.scrollTicking = false;
        });
        this.scrollTicking = true;
      }
    }

    _handleScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop > this.subcollectionsBounds.bottom) {
        if (!this.sticky()) {
          this.subcollections.classList.add('scrolled-past-subcollections');
          requestAnimationFrame(this.hide.bind(this));
          setTimeout(() => requestAnimationFrame(this.reveal.bind(this)), 100);
        }
      } else {
        this.subcollections.classList.remove('scrolled-past-subcollections');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.subcollections.classList.add('subcollections-hidden', 'subcollections-sticky');
      document.body.classList.add('body-subcollections-hidden', 'body-subcollections-sticky');
      this.setSubcollectionsHeight();
    }

    reveal() {
      this.subcollections.classList.add('subcollections-sticky', 'animate');
      this.subcollections.classList.remove('subcollections-hidden');
      document.body.classList.add('body-subcollections-sticky');
      document.body.classList.remove('body-subcollections-hidden');
      this.setSubcollectionsHeight();
    }

    reset() {
      this.subcollections.classList.remove('subcollections-hidden', 'subcollections-sticky', 'animate');
      document.body.classList.remove('body-subcollections-hidden', 'body-subcollections-sticky');
    }

    sticky() {
      return (
        this.subcollections.classList.contains('subcollections-sticky') &&
        !this.subcollections.classList.contains('subcollections-hidden') &&
        document.body.classList.contains('body-subcollections-sticky') &&
        !document.body.classList.contains('body-subcollections-hidden')
      );
    }
  }
)